<template>
  <BaseUpsell :dismissible="false">
    <template v-slot:icon>
      <BulkSendCircleIcon
        v-if="hasTried"
        :showPadlock="true"
        class="mb-base w-fifty"
        data-test="locked-icon"
      />
    </template>
    <template v-slot:title>
      <p
        class="text-black font-bold text-2xl"
        data-test="card-title"
      >
        {{ $t(hasTried ? 'upsells.bulkSend.lockedTitle' : 'upsells.bulkSend.title') }}
      </p>
    </template>
    <template v-slot:explainer>
      <p class="text-base text-black pb-base">
        <!-- TODO: update to `upsells.bulkSend.explainer` when video is added -->
        {{ $t('upsells.bulkSend.explainerNoVideo') }}
      </p>
    </template>
    <template v-slot:cta>
      <ButtonLink
        v-if="canUpgrade"
        :to="{ name: 'Billing', hash: '#plans' }"
        variant="primaryDark"
        class="w-full md:w-auto text-center"
        data-test="upgrade-button"
        data-ec="bulk_send_plu"
        :data-et="hasTried ? 'upgrade_link_locked' : 'upgrade_link'"
      >
        {{ $t('upsells.ctaTitle') }}
      </ButtonLink>
      <p
        v-else
        class="text-black font-bold"
        data-test="contact-admin-message"
      >
        {{ $t('upsells.contactAdminMessage') }}
        <BaseLink
          variant="invisible"
          size="none"
          href="https://www.signable.co.uk/plans/"
          target="_blank"
          class="font-normal"
          data-test="learn-more-message"
          data-ec="bulk_send_plu"
          :data-et="hasTried ? 'learn_more_locked' : 'learn_more'"
        >
          {{ $t('upsells.learnMoreMessage') }}
        </BaseLink>
      </p>
    </template>
    <!-- TODO: Include Video Component -->
    <!-- <template v-slot:media>
      <div>
        <img src="@/assets/bulk-send-help-video.png" class="rounded-2xl border-solid border-black border-1" />
      </div>
    </template> -->
  </BaseUpsell>
</template>

<script>
import { BaseUpsell } from '@/components/library/upsells';
import { BulkSendCircleIcon } from '@/components/icons';
import ButtonLink from '@/components/library/links/ButtonLink.vue';
import BaseLink from '@/components/library/links/BaseLink.vue';

export default {
  components: {
    BaseUpsell,
    ButtonLink,
    BaseLink,
    BulkSendCircleIcon,
  },
  props: {
    canUpgrade: {
      type: Boolean,
      required: true,
    },
    hasTried: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
